//extracted by mini-css-extract-plugin
export default {"textColor":"styles_textColor__R5Q6d","bold":"styles_bold__DwJga","copyButton":"styles_copyButton__HmMY5","link":"styles_link__8Ls4f","textOverflow":"styles_textOverflow__onB1R"};;